import { bindable, bindingMode } from "aurelia-framework";
import { IDisplaySetting } from "typings/project";

export class PropertiesTable {
  @bindable({ defaultBindingMode: bindingMode.twoWay })
  data: Array<IDisplaySetting> = [];
  @bindable title: string = "Properties";

  pageSize = 50;

  filters = [{ value: "", keys: ["displayName"] }];

  get filteredData() {
    const seen = new Set();
    return this.data.filter((prop) => {
      const isDuplicate = seen.has(prop.displayName);
      seen.add(prop.displayName);
      return !isDuplicate && prop.visible !== false;
    });
  }

  switchToggled(propertyName: string, displayName: string, newValue: boolean) {
    const partnerProperty = this.data.find(
      (x) => x.displayName === displayName && x.propertyName !== propertyName
    );
    if (partnerProperty) partnerProperty.enabled = newValue;
  }
}
